if (!customElements.get('tournaments-slider')) {
  customElements.define(
    'tournaments-slider',
    class TournamentsSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.desktopMedia = window.matchMedia('(min-width: 750px)');
        this.onLayoutChange = this.onLayoutChange.bind(this);
        this.onSwiperLoad = this.onSwiperLoad.bind(this);
      }

      connectedCallback() {
        this.viewport = this.querySelector('[data-tournaments-slider-viewport]');
        if (!this.viewport) return;

        this.desktopMedia.addEventListener('change', this.onLayoutChange);

        if (window.Swiper) {
          this.syncLayout();
          return;
        }

        this.swiperScript = document.getElementById('swiper-script');
        this.swiperScript?.addEventListener('load', this.onSwiperLoad, { once: true });
      }

      disconnectedCallback() {
        this.desktopMedia.removeEventListener('change', this.onLayoutChange);
        this.swiperScript?.removeEventListener('load', this.onSwiperLoad);
        this.destroy();
      }

      get shouldUseSlider() {
        const layout = this.desktopMedia.matches ? this.dataset.desktopLayout : this.dataset.mobileLayout;
        return layout === 'slider';
      }

      onLayoutChange() {
        this.syncLayout();
      }

      onSwiperLoad() {
        this.syncLayout();
      }

      syncLayout() {
        if (this.shouldUseSlider) {
          this.init();
          return;
        }

        this.destroy();
      }

      init() {
        if (this.swiper || !window.Swiper || !this.viewport) return;

        const slides = this.viewport.querySelectorAll('[data-tournament-slide]');
        if (slides.length <= 1) return;

        const previousButton = this.querySelector('[data-tournaments-slider-previous]');
        const nextButton = this.querySelector('[data-tournaments-slider-next]');
        const pagination = this.querySelector('[data-tournaments-slider-pagination]');

        this.swiper = new window.Swiper(this.viewport, {
          slidesPerView: 1.3,
          spaceBetween: 15,
          watchOverflow: true,
          resistanceRatio: 0,
          navigation: {
            prevEl: previousButton,
            nextEl: nextButton,
          },
          pagination: {
            el: pagination,
            clickable: true,
          },
          breakpoints: {
            750: {
              slidesPerView: 3.5,
              spaceBetween: 18,
            },
            1024: {
              slidesPerView: 4.6,
              spaceBetween: 20,
            },
          },
        });
      }

      destroy() {
        if (!this.swiper) return;
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  );
}